import React from 'react';
import { useTranslation } from 'react-i18next';
import DownloadOption from './DownloadOption';
var FreeDownloadOption = function (_a) {
    var freeDownload = _a.freeDownload, checked = _a.checked, onSelect = _a.onSelect;
    var t = useTranslation().t;
    return (React.createElement(DownloadOption, { value: "free", checked: checked, title: t('actionbar.download.free.size', {
            size: "".concat(freeDownload === null || freeDownload === void 0 ? void 0 : freeDownload.width, "x").concat(freeDownload === null || freeDownload === void 0 ? void 0 : freeDownload.height),
        }), onSelect: onSelect }));
};
FreeDownloadOption.displayName = 'FreeDownloadOption';
export default FreeDownloadOption;
//# sourceMappingURL=FreeDownloadOption.js.map